interface LogoProps {
  size?: number   // controls height in px
  light?: boolean // true = on dark background (use white logo), false = on light background
  onClick?: () => void
}

export function Logo({ size = 36, light = false, onClick }: LogoProps) {
  return (
    <img
      src={light ? '/logo-dark.png' : '/logo-light.png'}
      alt='DriveTrack'
      height={size}
      style={{ display: 'block', cursor: onClick ? 'pointer' : 'default' }}
      onClick={onClick}
    />
  )
}
